import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaFire, FaCrown, FaShieldAlt, FaArrowRight } from 'react-icons/fa';
import './Slida.css';

const MINISTRIES = [
  {
    icon: <FaHeart aria-hidden="true" />,
    badge: 'Couples & Families',
    title: 'Marrieds Ministry',
    description:
      'A vibrant community of couples cultivating love, laughter and legacy. Together we connect, grow and build marriages that honour God.',
    path: '/join-mc',
    cta: 'Connect With Marrieds',
  },
  {
    icon: <FaFire aria-hidden="true" />,
    badge: 'Youth & Young Adults',
    title: 'Youth Ministry (TCG)',
    description:
      'The Youth Experience (TCG) equips and empowers the next generation to live boldly for Jesus as faithful, influential leaders.',
    path: '/tcg-page',
    cta: 'Explore Youth Ministry',
  },
  {
    icon: <FaCrown aria-hidden="true" />,
    badge: 'Women of Purpose',
    title: 'Royal Women’s Ministry',
    description:
      'A place for women to connect, grow in faith and be transformed. Here they build relationships, develop their gifts and serve others.',
    path: '/join-mc',
    cta: 'Join Royal Women',
  },
  {
    icon: <FaShieldAlt aria-hidden="true" />,
    badge: 'Men of Honor',
    title: 'Kingsmen Men’s Ministry',
    description:
      'The Kingsmen is a fellowship building strong, Godly leaders, helping men lead, mentor and serve with integrity.',
    path: '/join-mc',
    cta: 'Join Kingsmen',
  },
];

const Slida = () => {
  return (
    <section className="tcc-section ministries" aria-labelledby="ministries-heading">
      <div className="tcc-container">
        <div className="ministries__head">
          <p className="tcc-eyebrow">Find your people</p>
          <h2 className="tcc-h2" id="ministries-heading">Our Ministries</h2>
          <p className="tcc-lead">
            Whatever season of life you’re in, there’s a community here for you.
          </p>
        </div>

        <ul className="ministries__grid">
          {MINISTRIES.map((m) => (
            <li className="ministry-card tcc-card tcc-card--hover" key={m.title}>
              <div className="ministry-card__header">
                <span className="ministry-card__icon">{m.icon}</span>
                <span className="ministry-card__badge">{m.badge}</span>
              </div>
              <div className="ministry-card__body">
                <h3 className="ministry-card__title">{m.title}</h3>
                <p className="ministry-card__text">{m.description}</p>
                <Link to={m.path} className="ministry-card__cta">
                  <span>{m.cta}</span>
                  <FaArrowRight aria-hidden="true" />
                </Link>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Slida;
